// utils/bannercopy.js

export const noticeText = '  ';

export const noticeHtml = '  ';